/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODLayoutBrand from "./brand.js";
import ODMenu from "./../../components/menu.js";
import ODLayoutAside from "./aside.js";

var ODLayoutAsideMenu = function() {
    // Private properties
    var _body;
    var _element;
    var _menuObject;

	// Initialize
	var _init = function() {
		var menuDesktopMode = (ODUtil.attr(_element, 'data-menu-dropdown') === '1' ? 'dropdown' : 'accordion');
        var scroll;

		if (ODUtil.attr(_element, 'data-menu-scroll') === '1') {
			scroll = {
				rememberPosition: true, // remember position on page reload
				height: function() { // calculate available scrollable area height
					var height = parseInt(ODUtil.getViewPort().height);

					if (ODUtil.isBreakpointUp('lg')) {
						height = height - ODLayoutBrand.getHeight();
					}

					height = height - (parseInt(ODUtil.css(_element, 'marginBottom')) + parseInt(ODUtil.css(_element, 'marginTop')));

					return height;
				}
			};
		}

		_menuObject = new ODMenu(_element, {
			// Vertical scroll
			scroll: scroll,

			// Submenu setup
			submenu: {
				desktop: menuDesktopMode,
				tablet: 'accordion', // menu set to accordion in tablet mode
				mobile: 'accordion' // menu set to accordion in mobile mode
			},

			// Accordion setup
			accordion: {
				expandAll: false // allow having multiple expanded accordions in the menu
			}
		});

        // Disable menu click if aside is fixed and minimized
        _menuObject.on('submenuToggle', function(menu) {
            if (ODLayoutAside.isMinimized() === true  && ODLayoutAside.isHoverable() === false) {
                return false;
            }
        });
	}

    var _initHover = function() {
        // Handle Minimized Aside Hover
		if (ODUtil.hasClass(_body, 'aside-fixed') && ODUtil.hasClass(_body, 'aside-minimize-hoverable')) {
			var insideTm;
			var outsideTm;

            // Handle Aside Hover Mode
			ODUtil.addEvent(_element, 'mouseenter', function(e) {
				e.preventDefault();

				if (ODUtil.isBreakpointUp('lg') === false) {
					return;
				}

				if (outsideTm) {
					clearTimeout(outsideTm);
					outsideTm = null;
				}

                if (insideTm) {
					clearTimeout(insideTm);
					insideTm = null;
				}

				insideTm = setTimeout(function() {
					if (ODUtil.hasClass(_body, 'aside-minimize') && ODUtil.isBreakpointUp('lg')) {
						// Hover class
						ODUtil.addClass(_body, 'aside-minimize-hover');

						ODLayoutAsideMenu.getMenu().scrollUpdate();
						ODLayoutAsideMenu.getMenu().scrollTop();
					}
				}, 50);
			});

			ODUtil.addEvent(ODLayoutAside.getElement(), 'mouseleave', function(e) {
				e.preventDefault();

				if (ODUtil.isBreakpointUp('lg') === false) {
					return;
				}

				if (insideTm) {
					clearTimeout(insideTm);
					insideTm = null;
				}

                if (outsideTm) {
					clearTimeout(outsideTm);
					outsideTm = null;
				}

				outsideTm = setTimeout(function() {
				    if (ODUtil.hasClass(_body, 'aside-minimize-hover') && ODUtil.isBreakpointUp('lg')) {
					    ODUtil.removeClass(_body, 'aside-minimize-hover');

						// Hover class
                        ODLayoutAsideMenu.getMenu().scrollUpdate();
						ODLayoutAsideMenu.getMenu().scrollTop();
					}
				}, 100);
			});
		}
	}

    // Public methods
	return {
		init: function(id) {
            _body = ODUtil.getBody();
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize menu
            _init();
            _initHover();
		},

		getElement: function() {
			return _element;
		},

        getMenu: function() {
			return _menuObject;
		},

        pauseDropdownHover: function(time) {
			if (_menuObject) {
				_menuObject.pauseDropdownHover(time);
			}
		},

		closeMobileOffcanvas: function() {
			if (_menuObject && ODUtil.isMobileDevice()) {
				_menuObject.hide();
			}
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutAsideMenu;
}

export default ODLayoutAsideMenu;
